import { useAtom } from 'jotai'
import { PanelLeft } from 'lucide-react'
import { Link, useLocation } from 'react-router-dom'

import { settingsSidebarAtom } from '../../atoms'
import { useSettingsTabs } from '../../hooks/settings/useSettingTabs'
import { Button } from '../ui/button'

const SettingsSidebar = () => {
  const location = useLocation()
  const items = useSettingsTabs()
  const [isOpen, setIsOpen] = useAtom(settingsSidebarAtom)

  const isActiveRoute = (route: string) => {
    return location.pathname === `/settings/${route}`
  }

  return (
    <div
      className={`bg-sidebar text-sidebar-foreground sticky top-0 h-screen overflow-x-hidden transition-all duration-200 ${
        isOpen ? 'w-64 px-2' : 'w-12'
      } flex flex-col border-r`}
    >
      <div className="flex items-center justify-between border-b p-4">
        <h2 className={`whitespace-nowrap text-lg font-semibold ${isOpen ? '' : 'hidden'}`}>
          Einstellungen
        </h2>
        <Button variant="ghost" size="icon" onClick={() => setIsOpen(!isOpen)}>
          <PanelLeft className="h-4 w-4" />
        </Button>
      </div>
      <nav className="flex-1 overflow-y-auto overflow-x-hidden">
        <ul className="space-y-2 py-4">
          {items
            .filter((item) => item.visible !== false)
            .map((item) => {
              const Icon = item.icon
              return (
                <li key={item.route}>
                  <Link
                    to={`/settings/${item.route}`}
                    className={`flex items-center gap-2 rounded p-2 text-sm transition-colors ${
                      isActiveRoute(item.route)
                        ? 'bg-sidebar-accent text-sidebar-accent-foreground'
                        : 'hover:bg-sidebar-accent hover:text-sidebar-accent-foreground'
                    } ${isOpen ? '' : 'justify-center'}`}
                  >
                    <Icon className="h-4 w-4 flex-shrink-0" />
                    <span className={`whitespace-nowrap ${isOpen ? '' : 'hidden'}`}>
                      {item.label}
                    </span>
                  </Link>
                </li>
              )
            })}
        </ul>
      </nav>
    </div>
  )
}

export default SettingsSidebar
